'use strict'

const burgerNav = () => {
    const mainMenu = jQuery('.main-menu-wrapper');
    const burgerButton = jQuery('.burger-menu');
    const body = jQuery('body');

    if (burgerButton.length > 0) {
        burgerButton.on('click', function () {

            jQuery(this).toggleClass('active');
            mainMenu.toggleClass('active');

            body.toggleClass('menu-open');
        });
    }
}

module.exports = {
    burgerNav
}